import React, { useMemo, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { FaFacebookF } from "react-icons/fa";
import ChatWidget from "./ChatWidget";
import leadsnow from "../assets/leadsnow-cleaning-logo.png";
import dusty from "../assets/dusty.png";
import vac from "../assets/vac.jpg";
import { useAppContext } from "../AppContext";
import plus from "../assets/ComCleanPlus.png";
import marketing from "../assets/marketing-kit.png";
import telemarekting from "../assets/telemarekting.png";
import posty from "../assets/posty.png";
import brochure from "../assets/brochure.png";
import image99 from "../assets/$99 value big.png";
import image49 from "../assets/$49 Com Cleaning.png";
import StripeFinalCodeCheck from "./StripeFinalCodeCheck";
import LanguageSwitcher from "./LanguageSwitcher";
import { ES_HOME_PATH, ES_CLIENTS_PATH, ES_PROMOTE_PATH } from "../routes";

const pageUrl = `https://www.commercialcleaningleadsforyou.com${ES_PROMOTE_PATH}`;

const PromocionarNegocioLimpieza = () => {
  const { buyNow, setBuyNow, loadingHeader, selectedPrice, setSelectedPrice, leadsCount, setLeadsCount } = useAppContext();
  const [openKeys, setOpenKeys] = useState(new Set());

  // Remove any Google Translate or other query params from Spanish URL (clean Spanish URLs)
  useEffect(() => {
    if (window.location.search) {
      window.history.replaceState(null, "", window.location.pathname);
    }
  }, []);

  const plans = [
    { qty: 50, price: 39 },
    { qty: 200, price: 99 },
    { qty: 500, price: 199 },
  ];

  const faqItems = useMemo(
    () => [
      { key: "1", question: "¿Cuál es la mejor forma de promocionar un negocio de limpieza?", answer: "El mejor enfoque combina un objetivo claro, contacto directo con los responsables de decisiones y un seguimiento constante con el tiempo." },
      { key: "2", question: "¿Cuánto cuesta promocionar un negocio de limpieza?", answer: "Los costos varían, pero el contacto dirigido con leads suele dar más control que la publicidad tradicional." },
      { key: "3", question: "¿Los negocios de limpieza nuevos pueden promocionarse con efectividad?", answer: "Sí. Los negocios nuevos suelen tener éxito al enfocarse en un nicho específico y usar contacto directo en lugar de publicidad amplia." },
      { key: "4", question: "¿Necesito una página web para promocionar mi negocio de limpieza?", answer: "Una web ayuda con la credibilidad, pero la promoción puede empezar con llamadas, correos y contacto directo." },
    ],
    []
  );

  const { leftItems, rightItems } = useMemo(() => {
    const mid = Math.ceil(faqItems.length / 2);
    return { leftItems: faqItems.slice(0, mid), rightItems: faqItems.slice(mid) };
  }, [faqItems]);

  function IconPill() {
    return (
      <span className="inline-flex items-center justify-center shrink-0" style={{ width: 26, height: 26, borderRadius: 999, color: "#1465B7", fontWeight: 800, lineHeight: 1, fontSize: 28 }} aria-hidden="true">+</span>
    );
  }
  function MinusBullet() {
    return (
      <span className="inline-flex items-center justify-center shrink-0" style={{ width: 22, height: 22, borderRadius: 999, color: "#fff", fontWeight: 900, lineHeight: 1, fontSize: 24 }} aria-hidden="true">−</span>
    );
  }
  function FaqCard({ item, open, onToggle }) {
    return (
      <div className="w-full">
        <button type="button" onClick={onToggle} aria-expanded={open} className="w-full text-left rounded-full border shadow-sm transition" style={{ background: "#E4F7F9", borderColor: "rgba(38,169,74,0.40)", padding: "12px 14px" }}>
          <div className="flex items-center gap-3">
            <IconPill />
            <h3 className="text-[#1465B7] text-lg font-medium leading-snug m-0">{item.question}</h3>
          </div>
        </button>
        <div className="overflow-hidden transition-[max-height,opacity,margin] duration-300 ease-in-out" style={{ maxHeight: open ? 240 : 0, opacity: open ? 1 : 0, marginTop: open ? 10 : 0 }}>
          <div className="rounded-2xl shadow-sm" style={{ background: "#2FA84F", padding: "14px 16px" }}>
            <div className="flex gap-3 items-start">
              <MinusBullet />
              <p className="text-white text-lg leading-relaxed">{item.answer}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Helmet>
        <title>Cómo Promocionar tu Negocio de Limpieza Comercial</title>
        <meta name="description" content="Aprende cómo promocionar tu negocio de limpieza con un sistema paso a paso y leads de limpieza comercial dirigidos." />
        <link rel="canonical" href={pageUrl} />
        <link rel="alternate" hrefLang="en" href="https://www.commercialcleaningleadsforyou.com/how%20to%20promote%20your%20commercial%20cleaning%20business" />
        <link rel="alternate" hrefLang="es" href={pageUrl} />
        <link rel="alternate" hrefLang="x-default" href="https://www.commercialcleaningleadsforyou.com/" />
        <meta name="language" content="Spanish" />
        <script type="application/ld+json">
          {`
{
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://www.commercialcleaningleadsforyou.com/#organization",
      "name": "Leads Now Commercial Cleaning",
      "url": "https://www.commercialcleaningleadsforyou.com/",
      "description": "Leads Now Commercial Cleaning ofrece leads de limpieza comercial y datos de contacto listos para usar, ayudando a los negocios de limpieza a conseguir nuevos clientes de forma constante.",
      "sameAs": [],
      "email": "leadsnowproducts@gmail.com",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "12020 Shamrock Plaza #200",
        "addressLocality": "Omaha",
        "addressRegion": "NE",
        "postalCode": "68154",
        "addressCountry": "US"
      },
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "customer support",
        "email": "leadsnowproducts@gmail.com",
        "availableLanguage": ["Spanish", "English"]
      }
    },
    {
      "@type": "WebSite",
      "@id": "https://www.commercialcleaningleadsforyou.com/#website",
      "url": "https://www.commercialcleaningleadsforyou.com/",
      "name": "Leads Now Commercial Cleaning",
      "publisher": {
        "@id": "https://www.commercialcleaningleadsforyou.com/#organization"
      },
      "inLanguage": "es-419"
    },
    {
      "@type": "WebPage",
      "@id": "${pageUrl}/#webpage",
      "url": "${pageUrl}",
      "name": "Cómo Promocionar tu Negocio de Limpieza Comercial",
      "description": "Una guía paso a paso que muestra cómo los negocios de limpieza comercial se promocionan y ganan clientes usando contacto dirigido y leads verificados.",
      "inLanguage": "es-419",
      "isPartOf": {
        "@id": "https://www.commercialcleaningleadsforyou.com/#website"
      },
      "publisher": {
        "@id": "https://www.commercialcleaningleadsforyou.com/#organization"
      },
      "mainEntity": [
        { "@id": "${pageUrl}/#howto" },
        { "@id": "${pageUrl}/#faq" },
        { "@id": "${pageUrl}/#service" }
      ]
    },

    {
      "@type": "HowTo",
      "@id": "${pageUrl}/#howto",
      "name": "Cómo Promocionar tu Negocio de Limpieza Comercial",
      "description": "Un enfoque repetible, paso a paso, que usan las empresas de limpieza comercial exitosas para ganar nuevos clientes de forma constante.",
      "inLanguage": "es-419",
      "totalTime": "P30D",
      "supply": [
        {
          "@type": "HowToSupply",
          "name": "Leads de limpieza comercial"
        }
      ],
      "step": [
        {
          "@type": "HowToStep",
          "position": 1,
          "name": "Define el tipo de clientes de limpieza que quieres",
          "text": "Ten claridad sobre a quién quieres llegar. Las empresas de limpieza exitosas se enfocan en tipos específicos de clientes, como edificios de oficinas, consultorios médicos o dentales, escuelas y guarderías, almacenes e instalaciones industriales, tiendas y centros comerciales, y administradores de propiedades y edificios multiinquilino."
        },
        {
          "@type": "HowToStep",
          "position": 2,
          "name": "Identifica a los responsables de decisiones que controlan los contratos de limpieza",
          "text": "Los contratos de limpieza normalmente los deciden dueños de negocios, gerentes de oficina, gerentes de instalaciones y administradores de propiedades. Para conseguir clientes, debes llegar a las personas que pueden decir que sí."
        },
        {
          "@type": "HowToStep",
          "position": 3,
          "name": "Usa leads de limpieza comercial para llegar a los negocios correctos",
          "text": "Los leads de limpieza comercial son contactos empresariales verificados que coinciden con tu mercado objetivo y te permiten llegar directamente a los responsables de decisiones, sin esperar referidos o consultas en línea."
        },
        {
          "@type": "HowToStep",
          "position": 4,
          "name": "Segmenta por ubicación, industria y tipo de edificio",
          "text": "Usa contacto dirigido segmentando tus leads por ciudad, condado o código postal, tipo de negocio, tamaño del edificio y estado de propiedad. Una mejor segmentación mejora las tasas de respuesta."
        },
        {
          "@type": "HowToStep",
          "position": 5,
          "name": "Elige un método de contacto y sé constante",
          "text": "La constancia importa más que la perfección. Los métodos de contacto comunes incluyen llamadas telefónicas, correos de presentación, correo directo y seguimiento con varios contactos."
        },
        {
          "@type": "HowToStep",
          "position": 6,
          "name": "Mide tus resultados y mejora tu estrategia",
          "text": "Mide lo que funciona dando seguimiento a quién responde, qué industrias convierten mejor y qué mensajes generan devoluciones de llamada. Con el tiempo, tu proceso se vuelve más eficiente y predecible."
        }
      ]
    },

    {
      "@type": "FAQPage",
      "@id": "${pageUrl}/#faq",
      "url": "${pageUrl}",
      "name": "Preguntas Frecuentes",
      "inLanguage": "es-419",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "¿Cuál es la mejor forma de promocionar un negocio de limpieza?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "El mejor enfoque combina un objetivo claro, contacto directo con los responsables de decisiones y un seguimiento constante con el tiempo."
          }
        },
        {
          "@type": "Question",
          "name": "¿Cuánto cuesta promocionar un negocio de limpieza?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Los costos varían, pero el contacto dirigido con leads suele dar más control que la publicidad tradicional."
          }
        },
        {
          "@type": "Question",
          "name": "¿Los negocios de limpieza nuevos pueden promocionarse con efectividad?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Sí. Los negocios nuevos suelen tener éxito al enfocarse en un nicho específico y usar contacto directo en lugar de publicidad amplia."
          }
        },
        {
          "@type": "Question",
          "name": "¿Necesito una página web para promocionar mi negocio de limpieza?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Una web ayuda con la credibilidad, pero la promoción puede empezar con llamadas, correos y contacto directo."
          }
        }
      ]
    },

    {
      "@type": "Service",
      "@id": "${pageUrl}/#service",
      "name": "Leads de Limpieza Comercial (500 Leads de Descarga Instantánea)",
      "description": "Leads de contacto empresarial verificados que coinciden con tu mercado objetivo y te ayudan a llegar a los responsables de decisiones de limpieza comercial. Elige tu código postal, descarga y segmenta 500 leads, lanza tu contacto y mide tus resultados.",
      "areaServed": [
        { "@type": "Country", "name": "United States" }
      ],
      "provider": {
        "@id": "https://www.commercialcleaningleadsforyou.com/#organization"
      },
      "offers": {
        "@type": "Offer",
        "url": "${pageUrl}",
        "priceCurrency": "USD",
        "price": "199.00",
        "availability": "https://schema.org/InStock",
        "name": "Comienza por solo $199",
        "description": "Solo $199 por 500 leads de limpieza comercial. Descarga al instante."
      }
    }
  ]
}
`}
        </script>
      </Helmet>

      <header className="relative bg-gradient-to-br from-cyan-200 via-blue-200 to-cyan-300 overflow-hidden">
        <div className="px-4 pt-4 md:px-0 md:pt-0 md:absolute md:top-6 md:right-6 z-30">
          <div className="flex items-center gap-4">
            <LanguageSwitcher />
            <a href="https://www.facebook.com/profile.php?id=61582707424269" target="_blank" rel="noopener noreferrer" className="group inline-block" aria-label="Facebook">
              <div className="inline-flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-full bg-[#1877F2] shadow-lg ring-1 ring-black/10 transition-transform group-hover:scale-110 active:scale-95">
                <FaFacebookF className="text-white" size={24} />
              </div>
            </a>
          </div>
        </div>
        <div className="absolute inset-0">
          <div className="absolute top-10 left-10 w-16 h-16 bg-white/20 rounded-full animate-bounce"></div>
          <div className="absolute top-32 right-20 w-12 h-12 bg-white/15 rounded-full animate-bounce"></div>
          <div className="absolute bottom-20 left-1/4 w-20 h-20 bg-white/10 rounded-full animate-bounce"></div>
        </div>

        <div className="relative z-10 container mx-auto px-4 pb-8 pt-2 md:pt-8">
          <div className={`max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 ${(buyNow === "payment" || buyNow === "download") ? "items-start" : "items-center"}`}>
            <div className="text-center lg:text-left min-w-0">
              <div className="mb-8 flex justify-center lg:justify-start">
                <img src={leadsnow} alt="Leads Now" className="w-[280px] lg:w-[220px]" />
              </div>
              <h1 className="text-4xl font-semibold text-[#1465B7] leading-tight">
                Cómo promocionar tu negocio de limpieza
              </h1>
              <h2 className="mt-5 text-xl md:text-2xl font-medium mb-4 max-w-xl text-[#1465B7]">
                Si buscas cómo promocionar tu negocio de limpieza, el enfoque más efectivo no es una sola táctica de marketing, sino un sistema de promoción repetible que pone tus servicios frente a los negocios correctos en el momento correcto.
              </h2>
              <h3 className="mt-4 text-lg font-medium text-[#26A94A] mb-8 max-w-xl mx-auto lg:mx-0">
                Aquí tienes un enfoque paso a paso que usan empresas de limpieza comercial exitosas para ganar clientes nuevos de forma constante.
              </h3>

              <div className="mt-7">
                <button
                  className="rounded-3xl border-2 border-[#1E7A4C] bg-[#FFE96A] px-6 py-3 text-sm font-extrabold text-[#1465B7] shadow-sm hover:brightness-95"
                  style={{ color: "#1465B7" }}
                  onClick={() => {
                    document.getElementById('service').scrollIntoView({ behavior: 'smooth' });
                  }}
                >
                  Comienza por solo $199
                </button>
              </div>
            </div>

            <div className="flex justify-center lg:justify-end min-w-0">
              <div className={`flex-shrink-0 md:min-w-md w-full ${(buyNow === "payment" || buyNow === "download") ? "lg:max-w-[28rem] lg:w-full" : "lg:min-w-md lg:w-80"} items-center`}>
                {buyNow === "home" && (
                  <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border-3 border-[#26A94A]">
                    <div className="flex">
                      <button className="flex-1 bg-[#26A94A] text-white p-4 font-semibold rounded-b-2xl">
                        <span className="text-white text-lg">Leads de Limpieza Comercial Para Ti</span>
                      </button>
                    </div>
                    <div className="px-5 py-4">
                      <p className="text-xl font-bold text-[#1465B7] mb-3 text-center font-semibold">Consigue tu lista ahora</p>
                      <p className="text-md text-gray-600 mb-4">Envíame {leadsCount} negocios de limpieza comercial cerca de mi código postal.</p>
                      <div className="flex justify-center mb-6">
                        <div className="w-full bg-[#BFEAF2] border-[3px] border-[#26A94A] rounded-xl overflow-hidden grid grid-cols-3">
                          {plans.map((p, idx) => (
                            <button key={p.qty} type="button" onClick={() => { setLeadsCount(p.qty); setSelectedPrice(p.price * 100); }} className={`py-2 flex flex-col items-center justify-center transition cursor-pointer ${idx !== 0 ? "border-l-[3px] border-[#26A94A]" : ""} ${leadsCount === p.qty ? "bg-[#85C1CF]" : ""}`}>
                              <span className="text-lg font-extrabold leading-none text-[#EAFB55] drop-shadow-[1.5px_1.5px_0px_#2E7D32]">{p.qty}</span>
                              <span className="text-sm font-extrabold leading-none text-[#1465B7]">Leads</span>
                              <span className="text-base sm:text-lg font-extrabold leading-none text-[#26A94A] my-1">${p.price}</span>
                            </button>
                          ))}
                        </div>
                      </div>
                      <div className="mt-8">
                        <button className="w-full bg-[#FAF26B] hover:bg-yellow-300 text-black font-bold py-4 rounded-full transition-colors border-3 border-[#26A94A] cursor-pointer" style={{ color: "#1465B7", fontSize: "28px" }} onClick={() => setBuyNow("payment")}>
                          Comprar ahora
                        </button>
                      </div>
                    </div>
                  </div>
                )}
                {(buyNow === "payment" || buyNow === "download") && <StripeFinalCodeCheck />}
              </div>
            </div>
          </div>
        </div>
      </header>

      <section className="w-full py-16" id="howto">
        <div className="mx-auto max-w-5xl px-4">
          <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
            <div className="rounded-2xl border-2 border-[#26A94A] bg-[#E0F7FA] p-6 shadow-sm">
              <h2 className="text-xl font-extrabold text-[#26A94A] mb-4">Paso 1: Decide a quién quieres promocionar tus servicios de limpieza</h2>
              <h3 className="mt-2 text-lg leading-7 text-[#26A94A]">La promoción funciona mejor cuando está enfocada.</h3>
              <p className="text-base text-[#1465B7] leading-relaxed">Antes de comercializar tu negocio de limpieza, define claramente los tipos de clientes que quieres alcanzar, como:</p>
              <ul className="my-4 list-disc space-y-2 pl-5 text-base text-[#1465B7]">
                <li>Edificios de oficinas</li>
                <li>Consultorios médicos o dentales</li>
                <li>Escuelas y guarderías</li>
                <li>Almacenes e instalaciones industriales</li>
                <li>Tiendas y centros comerciales</li>
                <li>Administradores de propiedades y edificios multiinquilino</li>
              </ul>
              <p className="text-base text-[#1465B7] leading-relaxed">Un objetivo claro hace que tu mensaje llegue a quien realmente contrata servicios de limpieza.</p>
            </div>
            <div className="rounded-2xl border-2 border-[#26A94A] bg-[#E0F7FA] p-6 shadow-sm">
              <h2 className="text-xl font-bold text-[#26A94A] mb-4">Paso 2: Llega a quienes toman las decisiones de limpieza</h2>
              <h3 className="mt-2 text-lg leading-7 text-[#26A94A]">Promocionar un negocio de limpieza no es solo visibilidad; es contactar a las personas correctas.</h3>
              <p className="text-base text-[#1465B7] leading-relaxed">Las empresas de limpieza suelen contactar prospectos a través de:</p>
              <ul className="my-4 list-disc space-y-2 pl-5 text-base text-[#1465B7]">
                <li>Dueños de negocios</li>
                <li>Gerentes de oficina</li>
                <li>Gerentes de instalaciones</li>
                <li>Administradores de propiedades</li>
              </ul>
              <p className="mt-4 text-base text-[#1465B7]">Una promoción efectiva se enfoca en estos responsables en lugar de contactos genéricos.</p>
            </div>
            <div className="rounded-2xl border-2 border-[#26A94A] bg-[#E0F7FA] p-6 shadow-sm">
              <h2 className="text-xl font-bold text-[#26A94A] mb-4">Paso 3: Usa contacto directo en lugar de esperar referidos</h2>
              <p className="text-base text-[#1465B7] leading-relaxed">Muchas empresas de limpieza dependen mucho de:</p>
              <ul className="my-4 list-disc space-y-2 pl-5 text-base text-[#1465B7]">
                <li>Referidos</li>
                <li>Anuncios en línea</li>
                <li>Redes sociales</li>
              </ul>
              <p className="mt-4 text-base text-[#1465B7]">Aunque pueden ayudar, son impredecibles. El contacto directo te permite promocionar activamente tu negocio de limpieza ante prospectos calificados en lugar de esperar a ser encontrado.</p>
            </div>
            <div className="rounded-2xl border-2 border-[#26A94A] bg-[#E0F7FA] p-6 shadow-sm">
              <h2 className="text-xl font-bold text-[#26A94A] mb-4">Paso 4: Promociona mejor con leads de limpieza comercial</h2>
              <h3 className="mt-2 text-lg leading-7 text-[#26A94A]">Una de las formas más eficientes de promocionar un negocio de limpieza es usar leads de limpieza comercial.</h3>
              <p className="text-base text-[#1465B7] leading-relaxed">Los leads de limpieza ofrecen información de contacto empresarial verificada y te permiten:</p>
              <ul className="my-4 list-disc space-y-2 pl-5 text-base text-[#1465B7]">
                <li>Presentar tus servicios directamente</li>
                <li>Llegar a responsables de decisiones sin adivinar</li>
                <li>Controlar qué tan rápido creces</li>
              </ul>
              <p className="mt-4 text-base text-[#1465B7]">Esto reduce la incertidumbre en la promoción.</p>
            </div>
            <div className="rounded-2xl border-2 border-[#26A94A] bg-[#E0F7FA] p-6 shadow-sm">
              <h2 className="text-xl font-bold text-[#26A94A] mb-4">Paso 5: Usa varios canales de promoción</h2>
              <h3 className="mt-2 text-lg leading-7 text-[#26A94A]">Los negocios de limpieza exitosos no dependen de un solo canal.</h3>
              <p className="text-base text-[#1465B7] leading-relaxed">Métodos comunes de promoción:</p>
              <ul className="my-4 list-disc space-y-2 pl-5 text-base text-[#1465B7]">
                <li>Llamadas</li>
                <li>Correos de presentación</li>
                <li>Correo directo</li>
                <li>Seguimiento con varios contactos</li>
              </ul>
              <p className="text-base text-[#1465B7] leading-relaxed">La constancia en todos los canales genera reconocimiento y confianza con el tiempo.</p>
            </div>
            <div className="rounded-2xl border-2 border-[#26A94A] bg-[#E0F7FA] p-6 shadow-sm">
              <h2 className="text-xl font-bold text-[#26A94A] mb-4">Paso 6: Mide resultados y mejora tu estrategia de promoción</h2>
              <h3 className="mt-2 text-lg leading-7 text-[#26A94A]">La promoción efectiva mejora cuando se mide.</h3>
              <p className="text-base text-[#1465B7] leading-relaxed">Mide: qué industrias responden mejor, qué mensajes generan llamadas y qué canales inician conversaciones. Con el tiempo, tu promoción será más eficiente y predecible.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="w-full pb-16">
        <div className="mx-auto max-w-5xl px-4">
          <div className="rounded-3xl border-2 border-[#26A94A] bg-[#E0F7FA] px-6 py-10 shadow-lg">
            <div className="flex flex-col md:flex-row items-center justify-between gap-10">
              <div className="hidden md:block shrink-0">
                <img src={vac} alt="Limpieza" className="h-[160px] w-auto" width={160} height={160} loading="lazy" />
              </div>
              <div className="flex-1 text-center">
                <h2 className="text-2xl font-bold text-[#26A94A] mb-6">Por qué este sistema de promoción funciona para negocios de limpieza</h2>
                <h3 className="mt-2 text-lg leading-7 text-[#26A94A]">Este enfoque funciona porque:</h3>
                <ul className="inline-block list-disc space-y-3 pl-8 text-left text-lg text-[#1465B7]">
                  <li>Se enfoca en prospectos calificados</li>
                  <li>Llega directamente a los responsables de decisiones</li>
                  <li>Genera un flujo constante de oportunidades</li>
                  <li>Reduce la dependencia solo de referidos</li>
                  <li>Escala conforme crece tu negocio de limpieza</li>
                </ul>
                <p className="mt-8 text-lg font-medium text-[#26A94A]">Es repetible, medible y pensado para crecer.</p>
                <div className="mt-8">
                  <button type="button" className="rounded-full border-2 border-[#1E7A4C] bg-[#FFE96A] px-12 py-4 text-lg font-extrabold text-[#1465B7] shadow-md hover:brightness-105 transition" style={{ color: "#1465B7" }} onClick={() => document.getElementById("service")?.scrollIntoView({ behavior: "smooth" })}>
                    Comienza por solo $199
                  </button>
                </div>
              </div>
              <div className="hidden md:block shrink-0">
                <img src={dusty} alt="Limpieza" className="h-[160px] w-auto" width={160} height={160} loading="lazy" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-[#DBE4E5]" id="service">
        <div className="relative z-10 container mx-auto px-4 py-8">
          <div className="block lg:flex max-w-5xl mx-auto">
            <div className="flex-1 max-w-xl text-center lg:text-left">
              <div className="mb-3 max-w-lg">
                <p className="text-[#26A94A] font-bold text-3xl">Comienza: <span className="text-[#1465B7]">Elige tu código postal, nosotros hacemos el resto.</span></p>
                <ul className="list-disc ml-5 text-lg text-gray-700">
                  <li>Descarga y segmenta los 500 leads de limpieza comercial según tus objetivos de marketing.</li>
                  <li className="my-2">Lanza tu contacto por correo, anuncios, llamadas o correo directo.</li>
                  <li>Mide tus resultados y afina para mejores resultados.</li>
                </ul>
                <p className="mt-3 text-gray-700 text-lg leading-normal">No necesitas una agencia ni un equipo de marketing grande. Solo la lista correcta y un plan claro. Tú consigues la lista, tú haces el contacto y te quedas con el 100% de las ganancias.</p>
                <div className="font-semibold text-[#26A94A] text-lg mt-3">
                  <p>Solo ${selectedPrice / 100} por {leadsCount} leads. Leads de Limpieza Comercial Para Ti</p>
                </div>
              </div>
            </div>
            {buyNow === "home" && (
              <div className="flex-shrink-0 md:min-w-md lg:min-w-md w-full lg:w-80">
                <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border-3 border-[#26A94A]">
                  <div className="flex">
                    <button className="flex-1 bg-[#26A94A] text-white p-4 font-semibold rounded-b-2xl">
                      <span className="text-white text-lg">Leads de Limpieza Comercial Para Ti</span>
                    </button>
                  </div>
                  <div className="px-5 py-4">
                    <p className="text-xl font-bold text-[#1465B7] mb-3 text-center font-semibold">Consigue tu lista ahora</p>
                    <p className="text-md text-gray-600 mb-4">Envíame {leadsCount} negocios de limpieza comercial cerca de mi código postal.</p>
                    <div className="flex justify-center mb-6">
                      <div className="w-full bg-[#BFEAF2] border-[3px] border-[#26A94A] rounded-xl overflow-hidden grid grid-cols-3">
                        {plans.map((p, idx) => (
                          <button key={p.qty} type="button" onClick={() => { setLeadsCount(p.qty); setSelectedPrice(p.price * 100); }} className={`py-2 flex flex-col items-center justify-center transition cursor-pointer ${idx !== 0 ? "border-l-[3px] border-[#26A94A]" : ""} ${leadsCount === p.qty ? "bg-[#85C1CF]" : ""}`}>
                            <span className="text-lg font-extrabold leading-none text-[#EAFB55] drop-shadow-[1.5px_1.5px_0px_#2E7D32]">{p.qty}</span>
                            <span className="text-sm font-extrabold leading-none text-[#1465B7]">Leads</span>
                            <span className="text-base sm:text-lg font-extrabold leading-none text-[#26A94A] my-1">${p.price}</span>
                          </button>
                        ))}
                      </div>
                    </div>
                    <div className="mt-8">
                      <button className="w-full bg-[#FAF26B] hover:bg-yellow-300 text-black font-bold py-4 rounded-full transition-colors border-3 border-[#26A94A] cursor-pointer" style={{ color: "#1465B7", fontSize: "28px" }} onClick={() => { setBuyNow("payment"); window.scrollTo({ top: 0, behavior: "smooth" }); }}>
                        Comprar ahora
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {(buyNow === "download") && <StripeFinalCodeCheck />}
            {buyNow === "payment" && (
              <button
                type="button"
                className="w-full bg-[#FAF26B] hover:bg-yellow-300 text-[#1465B7] font-bold py-4 rounded-full border-3 border-[#26A94A] cursor-pointer"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              >
                Completar el pago arriba ↑
              </button>
            )}
          </div>
        </div>
        <div className="container mx-auto max-w-5xl px-4 md:px-0">
          <div className="text-center mb-12">
            <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-5 justify-center sm:justify-between mx-auto">
              <img src={plus} width={200} height={125} alt="" />
              <div className="mt-4">
                <p className="text-3xl text-[#1465B7] font-bold">Estos <span className="text-[#26A94A]">extras</span> con cada pedido</p>
              </div>
              <img src={plus} width={200} height={125} className="hidden sm:block" alt="" />
            </div>
            <div className="container mx-auto max-w-5xl px-4 md:px-0 mt-8">
              <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-9 max-w-4xl justify-center mx-auto">
                <div>
                  <div className="relative flex justify-center items-center">
                    <div className="w-40 h-40 rounded-full flex items-center justify-center z-20"><img src={image99} width={130} alt="" /></div>
                    <div className="w-40 h-40 rounded-full flex items-center justify-center -ml-12 z-10"><img src={marketing} width={130} alt="" /></div>
                  </div>
                  <p className="text-[#1465B7] font-semibold text-lg leading-relaxed text-center mt-4 ml-4">¡Kit de marketing de limpieza comercial fácil!</p>
                </div>
                <div>
                  <div className="w-40 h-40 rounded-full flex items-center justify-center mx-auto"><img src={telemarekting} width={130} alt="" /></div>
                  <p className="text-[#1465B7] font-semibold text-lg leading-relaxed text-center">Script de buzón de voz</p>
                </div>
                <div>
                  <div className="w-40 h-40 rounded-full flex items-center justify-center mx-auto"><img src={posty} width={130} alt="" /></div>
                  <p className="text-[#1465B7] font-semibold text-lg leading-relaxed text-center">Plantillas de postales</p>
                </div>
                <div>
                  <div className="relative flex justify-center items-center">
                    <div className="w-40 h-40 rounded-full flex items-center justify-center z-20"><img src={image49} width={130} alt="" /></div>
                    <div className="w-40 h-40 rounded-full flex items-center justify-center -ml-12 z-10"><img src={brochure} width={130} alt="" /></div>
                  </div>
                  <p className="text-[#1465B7] font-semibold text-lg leading-relaxed text-center ml-6">Plantillas de folleto</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="max-w-5xl mx-auto">
        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <div className="text-center mb-6">
              <h2 className="text-2xl text-[#1465B7] font-semibold">Preguntas frecuentes</h2>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-6 px-4">
            <div className="space-y-4">
              {leftItems.map((item) => (
                <FaqCard key={item.key} item={item} open={openKeys.has(item.key)} onToggle={() => setOpenKeys((prev) => { const next = new Set(prev); if (next.has(item.key)) next.delete(item.key); else next.add(item.key); return next; })} />
              ))}
            </div>
            <div className="space-y-4">
              {rightItems.map((item) => (
                <FaqCard key={item.key} item={item} open={openKeys.has(item.key)} onToggle={() => setOpenKeys((prev) => { const next = new Set(prev); if (next.has(item.key)) next.delete(item.key); else next.add(item.key); return next; })} />
              ))}
            </div>
          </div>
        </section>
      </div>

      {/* Related guides - other page only (this page = Promote) */}
      <div className="bg-[#e8f4f6] py-6 border-t border-cyan-100">
        <div className="max-w-5xl mx-auto px-4">
          <p className="text-[#1465B7] font-semibold text-sm uppercase tracking-wide mb-3 text-center">
            Guías relacionadas
          </p>
          <p className="related-guides-links flex flex-wrap justify-center gap-x-4 gap-y-2 items-center text-center">
            <Link to={ES_HOME_PATH} onClick={() => window.scrollTo(0, 0)} className="text-[#26A94A] hover:text-[#1465B7] transition">Inicio</Link>
            <Link to={ES_CLIENTS_PATH} onClick={() => window.scrollTo(0, 0)} className="text-[#26A94A] hover:text-[#1465B7] transition">Cómo Conseguir Clientes para tu Negocio de Limpieza Comercial</Link>
          </p>
        </div>
      </div>

      <footer className="bg-[#BFEAF2] py-20 border-t border-cyan-100">
        <div className="max-w-5xl mx-auto px-4 text-center">
          <p className="text-xl font-medium text-[#26A94A] mb-4">
            Para cualquier problema, contacta a soporte:{" "}
            <a href="mailto:leadsnowproducts@gmail.com" className="underline hover:text-[#1465B7] transition">leadsnowproducts@gmail.com</a>
          </p>
          <p className="text-lg text-[#26A94A]">12020 Shamrock Plaza #200 Omaha, NE 68154</p>
        </div>
      </footer>

      <ChatWidget />
    </div>
  );
};

export default PromocionarNegocioLimpieza;
